import React from 'react';

import { TimePickerField as DSTimePickerField, TimePickerFieldProps as DSTimePickerFieldProps } from '@lumx/react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import './index.scss';

/** TimePickerField props */
export type TimePickerFieldProps = Omit<DSTimePickerFieldProps, 'translations'>;

const SCOPE = 'time-picker-field';

/**
 * Displays a time picker field wrapping the Design System TimePickerField with translations and data attributes.
 *
 * @family Pickers
 * @param TimePickerFieldProps
 * @returns TimePickerField
 */
export const TimePickerField: React.FC<TimePickerFieldProps> = ({ hasClearButton = false, ...props }) => {
    const { get } = useDataAttributes(SCOPE);
    const { translateKey } = useTranslate();

    return (
        <DSTimePickerField
            {...props}
            getOptionProps={(option) => {
                const extraProps = props.getOptionProps?.(option);
                return {
                    ...extraProps,
                    actionProps: { ...extraProps?.actionProps, ...get({ element: 'option' }) },
                };
            }}
            hasClearButton={hasClearButton}
            translations={{
                clearLabel: translateKey(GLOBAL.CLEAR),
                showSuggestionsLabel: translateKey(GLOBAL.SHOW_SUGGESTIONS),
            }}
        />
    );
};

TimePickerField.displayName = 'TimePickerField';
